// Tremor Card [v0.0.2] - No Radix Dependency

import React from 'react';

// Simple cx utility (if you don't have it elsewhere)
const cx = (...classes) => {
    return classes.filter(Boolean).join(' ');
};

const Card = React.forwardRef(({ className, asChild, children, ...props }, forwardedRef) => {
    // If asChild is true, we'll just return the children with merged props
    // This is a simplified version of what Slot does
    if (asChild && React.isValidElement(children)) {
        return React.cloneElement(children, {
            ...props,
            className: cx(
                // base
                'relative w-full rounded-lg border p-6 text-left shadow-sm',
                // background color
                'bg-white dark:bg-[#090E1A]',
                // border color
                'border-gray-200 dark:border-gray-900',
                className,
                children.props.className
            ),
            ref: forwardedRef,
        });
    }

    // Default behavior - render as div
    return (
        <div
            ref={forwardedRef}
            className={cx(
                // base
                'relative w-full rounded-lg border p-6 text-left shadow-sm',
                // background color
                'bg-white dark:bg-[#090E1A]',
                // border color
                'border-gray-200 dark:border-gray-900',
                className,
            )}
            tremor-id="tremor-raw"
            {...props}
        >
            {children}
        </div>
    );
});

Card.displayName = 'Card';

export { Card };